export default "/_next/static/chunks/fonts/Octicons-31d353daf64840110b3ddbfbfbb38fda.ttf";